import React, { FC, ReactNode, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import MobileActionBar from '../MobileActionBar';

type Props = {
  back?: string;
  // Where Continue goes after `submit` succeeds; or use onNext to handle it yourself.
  next?: string;
  submit?: () => Promise<boolean> | boolean;
  onNext?: () => void;
  label?: string;
  // Phones only: the action stays grey until the step is complete. Larger screens keep it
  // clickable and explain what is missing, as in the mockup.
  disabled?: boolean;
  busy?: boolean;
  // Shown under the action on phones, e.g. what is still missing.
  hint?: ReactNode;
  // Shown between Back and the action on larger screens, e.g. the out-of-pocket estimate.
  middle?: ReactNode;
};

// The step footer: on larger screens the mockup's "← Back … Continue" row; on phones the ADHD
// portal's sticky footer with the fee and a full-width action (back is in the step header).
const FooterNavigator: FC<Props> = ({
  back, next, submit, onNext, label = 'Continue', disabled, busy, hint, middle,
}) => {
  const { search } = useLocation();
  const navigate = useNavigate();

  const handleClickNext = useCallback(async () => {
    if (onNext) {
      onNext();
      return;
    }
    if (!next) return;
    if (!submit || await submit()) {
      navigate(`${next}${search}`);
    }
  }, [onNext, next, navigate, submit, search]);

  return (
    <>
      <div className="nav d-only">
        {back && <Link className="btn-t" to={`${back}${search}`}>← Back</Link>}
        <div className="sp" />
        {middle}
        <button type="button" className="btn btn-p" disabled={busy} onClick={handleClickNext}>
          {busy ? 'Please wait…' : label}
        </button>
      </div>
      <MobileActionBar label={label} onClick={handleClickNext} disabled={disabled} busy={busy} hint={hint} />
    </>
  );
};

export default FooterNavigator;
